import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../config';
import deviceInfoAxios from '../../utils/axios/deviceInfo.axios';

const tryToFetchLeoCosts = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/leo/costs?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/leo/costs?page=${pageNumber}&size=${pageSize}`;
    return deviceInfoAxios.put<any>(url, data);
};

const tryToFetchLeoStats = (data: any): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.put(`${DEVICE_INFO_API_URL}/leo/costs/analytics`, data);
};

const tryToFetchLeoCostsForClient = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/leo/costs`;
    return deviceInfoAxios.put<any>(url, data);
};

export const CostsService = {
    tryToFetchLeoStats,
    tryToFetchLeoCosts,
    tryToFetchLeoCostsForClient
};